import { Text, TextExtendedProps } from 'grommet'

export function XsmallText({ children, ...props }: TextExtendedProps) {
  return (
    <Text size="xsmall" weight={400} {...props}>
      {children}
    </Text>
  )
}
export const SmallText = ({ children, ...props }: TextExtendedProps) => {
  return (
    <Text size="small" weight={500} {...props}>
      {children}
    </Text>
  )
}

export function LargeText({ children, ...props }: TextExtendedProps) {
  return (
    <Text size="large" weight={700} {...props}>
      {children}
    </Text>
  )
}
